import { render } from "./TrustBlock.vue?vue&type=template&id=06244297&scoped=true"
import script from "./TrustBlock.vue?vue&type=script&lang=js"
export * from "./TrustBlock.vue?vue&type=script&lang=js"

import "./TrustBlock.vue?vue&type=style&index=0&id=06244297&lang=scss&scoped=true"

import exportComponent from "/home/romych/projects/vue.home.zina.design/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06244297"]])

export default __exports__